import React from 'react';
import './PDFLayoutStep.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';

const PDFLayoutStep = ({ selectedLayout, onLayoutSelect }) => {
    
    const layouts = [
        {
            id: 'alternado',
            name: 'Alternado',
            description: 'Imagen y detalles alternados en cada fila'
        },
        {
            id: 'doble-columna',
            name: 'Doble Columna',
            description: 'Dos productos por fila con imágenes arriba'
        },
        {
            id: 'grid-3x3',
            name: 'Grid 3x3',
            description: 'Tres productos por fila en formato compacto'
        }
    ];

    return (
        <div className="pdf-layout-step-container">
            <div className="pdf-layout-grid">
                
                {layouts.map((layout) => (
                    <div
                        key={layout.id}
                        className={`pdf-layout-card ${selectedLayout === layout.id ? 'selected' : ''}`}
                        onClick={() => onLayoutSelect(layout.id)}
                    >
                        <div className="pdf-layout-preview">
                            {layout.id === 'alternado' && <LayoutAlternado />}
                            {layout.id === 'doble-columna' && <LayoutDobleColumna />}
                            {layout.id === 'grid-3x3' && <LayoutGrid3x3 />}
                        </div>
                        <div className="pdf-layout-info">
                            <h4>{layout.name}</h4>
                            <p>{layout.description}</p>
                        </div>
                        {selectedLayout === layout.id && (
                            <div className="pdf-layout-selected-badge">
                                ✓ Seleccionado
                            </div>
                        )}
                    </div>
                ))}

            </div>
        </div>
    );
};

// Layout A: Alternado
const LayoutAlternado = () => (
    <div className="layout-skeleton layout-alternado">
        {/* Fila 1: Imagen izq, detalles der */}
        <div className="layout-row">
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
                <div className="skeleton-line skeleton-line-text short"></div>
            </div>
        </div>
        
        {/* Fila 2: Detalles izq, imagen der */}
        <div className="layout-row">
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
                <div className="skeleton-line skeleton-line-text short"></div>
            </div>
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
        </div>
        
        {/* Fila 3: Imagen izq, detalles der */}
        <div className="layout-row">
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
                <div className="skeleton-line skeleton-line-text short"></div>
            </div>
        </div>
        
        {/* Fila 4: Detalles izq, imagen der */}
        <div className="layout-row">
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
                <div className="skeleton-line skeleton-line-text short"></div>
            </div>
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
        </div>
    </div>
);

// Layout B: Doble Columna
const LayoutDobleColumna = () => (
    <div className="layout-skeleton layout-doble-columna">
        {/* Producto 1 */}
        <div className="layout-product-item">
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
            </div>
        </div>
        
        {/* Producto 2 */}
        <div className="layout-product-item">
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
            </div>
        </div>
        
        {/* Producto 3 */}
        <div className="layout-product-item">
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
            </div>
        </div>
        
        {/* Producto 4 */}
        <div className="layout-product-item">
            <div className="skeleton-box skeleton-image">
                <FontAwesomeIcon icon={faImage} className="skeleton-image-icon" />
            </div>
            <div className="skeleton-box skeleton-details">
                <div className="skeleton-line skeleton-line-title"></div>
                <div className="skeleton-line skeleton-line-text"></div>
            </div>
        </div>
    </div>
);

// Layout C: Grid 3x3
const LayoutGrid3x3 = () => (
    <div className="layout-skeleton layout-grid-3x3">
        {/* Fila 1 */}
        <div className="layout-grid-row">
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
        </div>
        
        {/* Fila 2 */}
        <div className="layout-grid-row">
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
        </div>

        {/* Fila 3 */}
        <div className="layout-grid-row">
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
            <div className="layout-grid-item">
                <div className="skeleton-box skeleton-image small">
                    <FontAwesomeIcon icon={faImage} className="skeleton-image-icon small" />
                </div>
                <div className="skeleton-box skeleton-details compact">
                    <div className="skeleton-line skeleton-line-title small"></div>
                    <div className="skeleton-line skeleton-line-text small"></div>
                </div>
            </div>
        </div>
    </div>
);

export default PDFLayoutStep;
